import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-item-list-heading" }
const _hoisted_2 = { class: "c-item-list-heading__title" }
const _hoisted_3 = { class: "c-item-list-heading__title_en" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.titleEn), 1)
  ]))
}